import { render, staticRenderFns } from "./CreateCDQR.vue?vue&type=template&id=bd05efd8&scoped=true&"
import script from "./CreateCDQR.vue?vue&type=script&lang=ts&"
export * from "./CreateCDQR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd05efd8",
  null
  
)

export default component.exports